import { ApiClient } from '../../../api/ApiClient';
import { ActionType } from '../../ActionTypes';
import { store as baseStore } from '../../Store';
import { IncompleteUser } from '../UserState';
import { handleUserError, validateUserIsNotAuthenticated } from '../Utils';

/** Given a userId, setup the user ready for purchasing. */
export async function setupIncompleteUser(userId: string, store = baseStore): Promise<void> {
  try {
    store.dispatch({ type: ActionType.SETUP_INCOMPLETE_USER_LOADING });

    validateUserIsNotAuthenticated();

    const apiClient = new ApiClient();
    const { email } = await apiClient.getEmailFromUserId({ userId });

    // setupIncompleteUser is triggered by the /start flow with the userId passed in as a query param
    // so the assumption is that the user already exists, hence setUserPassword = false
    const user: IncompleteUser = {
      type: 'partial',
      userId,
      email,
      setUserPassword: false,
      hasPaid: false,
    };

    store.dispatch({ type: ActionType.SETUP_INCOMPLETE_USER_SUCCESS, user });
  } catch (rawError) {
    const error = handleUserError(rawError);
    store.dispatch({ type: ActionType.SETUP_INCOMPLETE_USER_FAILURE, error });
  }
}
